import { render, staticRenderFns } from "./value-input.vue?vue&type=template&id=2be4590e&scoped=true&"
import script from "./value-input.vue?vue&type=script&lang=js&"
export * from "./value-input.vue?vue&type=script&lang=js&"
import style0 from "./value-input.vue?vue&type=style&index=0&id=2be4590e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be4590e",
  null
  
)

export default component.exports